<template>
  <div
    class="report_container"
    v-loading="data_loading"
    element-loading-text="数据加载中···"
  >
    <!-------------------我的评测----------------->
    <div
      class="report_list"
      v-if="reportCarListRef && reportCarListRef.length > 0"
    >
      <!-- <div class="list_header flex">
        <h2>我的车型评测</h2>
      </div> -->

      <div class="list_body">
        <template v-if="reportCarListRef && reportCarListRef.length > 1">
          <ModelList
            @changeModel="changeModel"
            :curid="reportCarListRef[list_current_ind].model_id"
            :list="reportCarListRef"
          />
        </template>

        <div class="item_block cur_car_info">
          <div class="cur_car_info_top flex">
            <div class="cur_car_info_left">
              <div class="cur_car_info_img">
                <img
                  :src="reportCarListRef[list_current_ind].car_info.model_img"
                />
              </div>
              <div class="cur_car_info_name">
                {{ reportCarListRef[list_current_ind].car_info.brand }}
                {{ reportCarListRef[list_current_ind].car_info.model_name }}
                {{ reportCarListRef[list_current_ind].car_info.year }}
              </div>

              
              <!-- <div
                class="car_info_change_model"
                @click.self="
                  changeCar(reportCarListRef[list_current_ind].model_id)
                "
              >
                更换车型
              </div> -->
              <div class="cur_car_info_price">
                <div class="price_attr">指导价：</div>
                <div class="price_val">
                  {{ reportCarListRef[list_current_ind].car_info.price }}万元
                </div>
              </div>

              <div class="cur_car_info_price">
                <div class="price_attr">评测体系版本：</div>
                <div class="price_val">
                  {{ reportCarListRef[list_current_ind].review_model_id == 1 ? '5.0' : '4.0' }}
                </div>
              </div>
              <div class="cur_car_info_price" v-if="reportCarListRef[list_current_ind].car_info.sys_name">
                <div class="price_attr">系统版本：</div>
                <div class="price_val">
                  {{ reportCarListRef[list_current_ind].car_info.sys_name }}
                </div>
              </div>
              <div class="cur_car_info_starts">
                <el-rate :modelValue="reportCarListRef[list_current_ind].stars_per" disabled :colors="['#8E8CEF', '#8E8CEF', '#8E8CEF']" void-color="#e7e9f5" disabled-void-color="#e7e9f5"/>
              </div>
            </div>
            <div class="cur_car_info_right">
              <div class="cur_car_info_right_top flex">
                <div class="cur_car_info_right_item">
                  <div class="cur_car_info_item_attr score_composite_attr flex">
                    <span> 综合得分 </span>
                    <el-popover placement="top" width="auto" trigger="hover">
                      <div class="rulePop">
                        （综合得分包含基础得分+创新得分）
                      </div>
                      <template #reference>
                        <span class="tip_icon"></span>
                      </template>
                    </el-popover>
                    <span>：</span>
                  </div>
                  <div class="cur_car_info_item_val">
                    {{ reportCarListRef[list_current_ind].total_score }}
                  </div>
                </div>

                <div class="cur_car_info_right_item">
                  <div class="cur_car_info_item_attr">综合排名：</div>
                  <div class="cur_car_info_item_val">
                    {{ reportCarListRef[list_current_ind].rank }}
                  </div>
                </div>

                <div class="cur_car_info_right_item cur_car_info_test_time">
                  <div class="cur_car_info_test_attr">测试时间：</div>
                  <div class="cur_car_info_test_val">
                    {{
                      reportCarListRef[list_current_ind].publish_time.split(
                        " "
                      )[0]
                    }}
                  </div>
                </div>
              </div>

              <div class="cur_car_info_experts_read">
                <div class="experts_read_attr">专家解读</div>
                <p
                  class="experts_read_desc text_ellipsis_4"
                  v-html="reportCarListRef[list_current_ind].content"
                ></p>
              </div>
              <div class="cur_car_info_btns flex">
                <router-link
                  class="cur_car_info_btn btn_function"
                  :to="{
                    path: '/v2/summary/first',
                    query: {
                      model_img:reportCarListRef[list_current_ind].car_info.model_img,
                      model_name:
                        reportCarListRef[list_current_ind].car_info.short_name ||
                        reportCarListRef[list_current_ind].car_info.model_name,
                      model_id: reportCarListRef[list_current_ind].model_id,
                      report_id: reportCarListRef[list_current_ind].report_id,
                    },
                  }"
                >
                  <div class="cur_car_info_btn_icon icon_gnbgfx"></div>
                  <div class="cur_car_info_btn_text">
                    <div class="cur_car_info_btn_tit">功能标杆分析</div>
                    <div class="cur_car_info_btn_desc">点击查看详情</div>
                  </div>
                  <div class="cur_car_info_btn_icon icon_right"></div>
                </router-link>
                <router-link
                  class="cur_car_info_btn btn_scenario"
                  :to="{
                    path: '/v2/funcVideo',
                    query: {
                      model_img: reportCarListRef[list_current_ind].car_info.model_img,
                      model_name:
                        reportCarListRef[list_current_ind].car_info.short_name ||
                        reportCarListRef[list_current_ind].car_info.model_name,
                      model_id: reportCarListRef[list_current_ind].model_id,
                      report_id: reportCarListRef[list_current_ind].report_id,
                    },
                  }"
                >
                  <div class="cur_car_info_btn_icon icon_hxcjfx"></div>
                  <div class="cur_car_info_btn_text">
                    <div class="cur_car_info_btn_tit">核心场景分析</div>
                    <div class="cur_car_info_btn_desc">点击查看详情</div>
                  </div>
                  <div class="cur_car_info_btn_icon icon_right"></div>
                </router-link>
              </div>
            </div>
          </div>
          <div
            class="cur_car_info_bot"
            v-if="
              reportCarListRef &&
              reportCarListRef[list_current_ind] &&
              reportCarListRef[list_current_ind].length
            "
          >
            <div class="cur_car_info_parameter flex">
              <div class="sprite_icon icon_cxcs"></div>
              <div class="cur_car_info_parameter_tit">车型参数</div>
              <div
                class="cur_car_info_parameter_btn"
                @click.self="
                  openCarAttrDrawer(
                    reportCarListRef[list_current_ind].model_id,
                    1
                  )
                "
              >
                查看更多
              </div>
            </div>
            <div class="parameter_details flex">
              <div class="parameter_detail_item">
                <div class="parameter_detail_item_icon icon_nylx"></div>
                <div class="parameter_detail_item_attr">能源类型</div>
                <div class="parameter_detail_item_val">
                  {{
                    getEnergyType(
                      reportCarListRef[list_current_ind].car_info.energy_type
                    ) || "-"
                  }}
                </div>
              </div>
              <div class="parameter_detail_item">
                <div class="parameter_detail_item_icon icon_xtmc"></div>
                <div class="parameter_detail_item_attr">系统名称</div>
                <div class="parameter_detail_item_val">
                  {{
                    reportCarListRef[list_current_ind]["car_attr"][0][
                      "attr_value"
                    ] || "-"
                  }}
                </div>
              </div>
              <div class="parameter_detail_item">
                <div class="parameter_detail_item_icon icon_xtbb"></div>
                <div class="parameter_detail_item_attr">系统版本</div>
                <div class="parameter_detail_item_val">
                  {{
                    reportCarListRef[list_current_ind]["car_attr"][1][
                      "attr_value"
                    ] || "-"
                  }}
                </div>
              </div>
              <div class="parameter_detail_item">
                <div class="parameter_detail_item_icon icon_ykzqgys"></div>
                <div class="parameter_detail_item_attr">域控制器供应商</div>
                <div class="parameter_detail_item_val">
                  {{
                    reportCarListRef[list_current_ind]["car_attr"][2][
                      "attr_value"
                    ] || "-"
                  }}
                </div>
              </div>
              <div class="parameter_detail_item">
                <div class="parameter_detail_item_icon icon_zkxp"></div>
                <div class="parameter_detail_item_attr">主控芯片</div>
                <div class="parameter_detail_item_val">
                  {{
                    reportCarListRef[list_current_ind]["car_attr"][3][
                      "attr_value"
                    ] || "-"
                  }}
                </div>
              </div>
              <div class="parameter_detail_item">
                <div class="parameter_detail_item_icon icon_fzjsjb"></div>
                <div class="parameter_detail_item_attr">辅助驾驶级别</div>
                <div class="parameter_detail_item_val">
                  {{
                    reportCarListRef[list_current_ind]["car_attr"][4][
                      "attr_value"
                    ] || "-"
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="car_score_group car_graph flex_between">
          <div class="car_score_item item_block car_score_base">
            <div class="car_score_item_tit flex flex_align_center">
              <i class="sprite_icon icon_jcdf"></i>
              <span>基础得分：</span>
              <span class="car_score_num">
                {{ reportCarListRef[list_current_ind].base_score }}分
              </span>
              <router-link
                class="car_score_item_detail_btn"
                :to="{
                  path: '/v2/contrast/analyse/base',
                  query: {
                    model_img:reportCarListRef[list_current_ind].car_info.model_img,
                    model_name:reportCarListRef[list_current_ind].car_info.short_name || reportCarListRef[list_current_ind].car_info.model_name,
                    model_id: reportCarListRef[list_current_ind].model_id,
                    report_id: reportCarListRef[list_current_ind].report_id,
                  },
                }"
                >更多</router-link
              >
            </div>
            <div class="flex score_box flex_col">
              <div
                class="score_item"
                v-for="(item, ind) of reportCarListRef[list_current_ind]
                  .performance_score_detail"
                :key="item.node_id"
              >
                <div class="score_item_top flex flex_between">
                  <div class="score_item_label flex">
                    <span class="score_item_node_name">
                      {{ item.node_name }}
                    </span>
                    <span class="font_000"> （ </span>
                    <span class="font_000">
                      {{ item.score }}
                    </span>
                    <span> /{{ item.total_score }}{{ !ind ? "分" : "" }} </span>
                    <span class="font_000"> ） </span>
                  </div>
                  <div class="score_item_percent">
                    {{ ((item.score / item.total_score) * 100).toFixed(2) }}%
                  </div>
                </div>
                <div class="score_item_bottom">
                  <el-progress
                    v-if="item.score > -1 && item.total_score > 0"
                    :show-text="false"
                    :percentage="
                      ((item.score / item.total_score) * 100).toFixed(2)
                    "
                    color="#1FBCBF"
                  >
                  </el-progress>
                </div>
              </div>
            </div>
          </div>
          <div class="car_score_item item_block car_score_innovate">
            <div class="car_score_item_tit flex flex_align_center">
              <i class="sprite_icon icon_cxdf"></i>
              <span>创新得分</span>
              <el-popover placement="bottom" width="auto" trigger="hover">
                <div class="rulePop">
                  （创新得分仅计算实际得分，总分不设上限）
                </div>
                <template #reference>
                  <span class="tip_icon"></span>
                </template>
              </el-popover>
              <span>：</span>
              <span class="car_score_num">
                {{ reportCarListRef[list_current_ind].innovate_score || 0 }}分
              </span>
              <router-link
                class="car_score_item_detail_btn"
                :to="{
                  path: '/v2/contrast/evaluation',
                  query: {
                    model_img:reportCarListRef[list_current_ind].car_info.model_img,
                    model_name:
                      reportCarListRef[list_current_ind].car_info.short_name ||
                      reportCarListRef[list_current_ind].car_info.model_name,
                    model_id: reportCarListRef[list_current_ind].model_id,
                    report_id: reportCarListRef[list_current_ind].report_id,
                    type: 1,
                  },
                }"
              >
                更多
              </router-link>
            </div>
            <div class="flex score_box flex_col">
              <div
                class="score_item"
                v-for="(item, ind) of reportCarListRef[list_current_ind]
                  .innovate_score_detail"
                :key="item.node_id"
              >
                <div class="score_item_top flex flex_between">
                  <div class="score_item_label flex">
                    <span class="score_item_node_name">
                      {{ item.node_name }}
                    </span>
                    <span class="font_000"> （ </span>
                    <span class="font_000">
                      {{ item.total_score }}{{ !ind ? "分" : "" }}
                    </span>
                    <span class="font_000"> ） </span>
                  </div>
                </div>
                <div class="score_item_bottom">
                  <div
                    class="score_item_innovete"
                    :style="{
                      width:
                        item.total_score >= 100
                          ? '100%'
                          : item.total_score <= 0
                          ? '4px'
                          : item.total_score + '%',
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="car_graph flex_between">
          <div class="item_block score_func">
            <div class="car_score_item_tit flex flex_align_center">
              <i class="sprite_icon icon_gngl"></i>
              <span>功能概览</span>

              <router-link
                class="car_score_item_detail_btn"
                :to="{
                  path: '/v2/contrast/analyse/func',
                  query: {
                    model_img:reportCarListRef[list_current_ind].car_info.model_img,
                    model_name:
                      reportCarListRef[list_current_ind].car_info.short_name ||
                      reportCarListRef[list_current_ind].car_info.model_name,
                    model_id: reportCarListRef[list_current_ind].model_id,
                    report_id: reportCarListRef[list_current_ind].report_id,
                  },
                }"
                >更多</router-link
              >
            </div>
            <div class="chart_box">
              <template
                v-if="reportCarListRef[list_current_ind].function_score_detail"
              >
                <v-chart
                  class="radar_chart"
                  :option="radar_chart_options"
                  style="width: 500px; height: 350px"
                />
              </template>
            </div>
          </div>
          <div class="item_block score_trip">
            <div class="car_score_item_tit flex flex_align_center">
              <i class="sprite_icon icon_ltcj"></i>
              <span>旅途场景</span>
              <!-- 旅途node_id 为3 -->
              <router-link
                class="car_score_item_detail_btn"
                :to="{
                  path: '/v2/contrast/analyse/trip',
                  query: {
                    model_img:reportCarListRef[list_current_ind].car_info.model_img,
                    model_name:
                      reportCarListRef[list_current_ind].car_info.short_name ||
                      reportCarListRef[list_current_ind].car_info.model_name,
                    model_id: reportCarListRef[list_current_ind].model_id,
                    report_id: reportCarListRef[list_current_ind].report_id,
                  },
                }"
                >更多</router-link
              >
            </div>
            <div
              class="score_trip_box"
              v-if="reportCarListRef[list_current_ind].trip_score_detail"
            >
              <div
                class="score_row"
                v-for="(trip_row, index) of reportCarListRef[list_current_ind]
                  .trip_score_detail"
                :key="index"
              >
                <div
                  class="score_item"
                  v-for="trip_item of trip_row"
                  :key="trip_item.node_id"
                >
                  <div class="score_item_attr">{{ trip_item.node_name }}</div>
                  <div class="score_item_val">{{ trip_item.score }}/{{ trip_item.total_score }}分</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="car_graph flex_between">
          <div class="item_block car_hypj">
            <div class="car_score_item_tit flex flex_align_center">
              <i class="sprite_icon icon_hypj"></i>
              <span>行业评级</span>
              <el-popover placement="bottom" width="auto" trigger="hover">
                <div class="rulePop">
                  下图将纵向展示我的车型在整个行业金字塔模型中所处的位置和统计竞品数量
                </div>
                <template #reference>
                  <span class="tip_icon"></span>
                </template>
              </el-popover>
            </div>
            <div class="analyse_chart">
              <div class="hypj">
                <div
                  :class="
                    'hypj_content hypj_level' +
                    (reportCarListRef[list_current_ind].total_all_score > 949
                      ? 1
                      : reportCarListRef[list_current_ind].total_all_score > 849
                      ? 2
                      : reportCarListRef[list_current_ind].total_all_score > 749
                      ? 3
                      : reportCarListRef[list_current_ind].total_all_score > 649
                      ? 4
                      : 5)
                  "
                >
                  <div class="hypj_active">
                    <div class="hypj_active_icon"></div>
                    <div class="hypj_active_info">
                      <div class="hypj_active_info_name">
                        {{
                          reportCarListRef[list_current_ind].car_info.model_name
                        }}
                      </div>
                      <div class="hypj_active_info_score">
                        {{
                          reportCarListRef[list_current_ind].total_all_score
                        }}分
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="score_counts"
                  v-if="score_counts && score_counts.length > 0"
                >
                  <div
                    class="score_count"
                    :class="'score_count' + ind"
                    v-for="(item, ind) in score_counts"
                    :key="ind"
                  >
                    ({{ item }}个)
                  </div>
                </div>
                <div class="hypj_score">
                  <div class="hypj_score_item"></div>
                  <div class="hypj_score_item">950分</div>
                  <div class="hypj_score_item">850分</div>
                  <div class="hypj_score_item">750分</div>
                  <div class="hypj_score_item">650分</div>
                  <div class="hypj_score_item">0分</div>
                </div>
              </div>
            </div>
          </div>

          <div class="item_block car_lbfb">
            <div class="car_score_item_tit flex flex_align_center">
              <i class="sprite_icon icon_lbfb"></i>
              <span>类别分布</span>
              <el-popover placement="bottom" width="auto" trigger="hover">
                <div class="rulePop">
                  下图将横向展示我的车型在同品牌类型中基于价格和智能化程度的分布情况
                </div>
                <template #reference>
                  <span class="tip_icon"></span>
                </template>
              </el-popover>
              <div class="preview_big" @click="preview_big = true">全部</div>
            </div>
            <div class="lbfb_content">
              <v-chart
                class="scatter_chart"
                :option="scatterOptions"
                :style="{
                  height: '285px',
                  width: '450px',
                }"
                :loading="scatterLoading"
                :loadingOptions="scatterLoadingOptions"
                autoresize
                ref="scatterChartDom"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="list_header flex"
        v-if="
          reportCarListRef[list_current_ind].innovate_video &&
          reportCarListRef[list_current_ind].innovate_video.length > 0
        "
      >
        <h2>车型亮点功能视频</h2>
      </div>
      <div
        class="item_block light_video"
        v-if="
          reportCarListRef[list_current_ind].innovate_video &&
          reportCarListRef[list_current_ind].innovate_video.length > 0
        "
      >
        <div
          class="video_item"
          v-for="(item, ind) in reportCarListRef[list_current_ind]
            .innovate_video"
          :key="ind"
          @click="playVideo(item)"
        >
          <div class="video_item_img">
            <video
              :src="item.attach_value"
              :poster="
                item.attach_value +
                '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
              "
              preload="none"
            ></video>
          </div>
          <div class="video_item_tit">
            {{ item.node_name }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="preview_big_box" v-if="preview_big">
    <v-chart
      class="scatter_chart"
      :option="scatterOptions_big"
      :style="{
        height: '90vh',
        width: '100vw',
      }"
      :loading="scatterLoading"
      :loadingOptions="scatterLoadingOptions"
      autoresize
      ref="scatterChartDom"
    />
    <div class="btn_close" @click="preview_big = false"></div>
  </div>
  <CarAttr ref="carAttrDrawer" />
  <div class="video_pop" v-show="video_show">
    <div class="video_content">
      <video controlsList="nodownload"
        :src="video_src"
        autoplay
        controls
        :poster="
          video_src +
          '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
        "
        preload="metadata"
      ></video>
      <div class="video_close" @click="stopVideo"></div>
    </div>
  </div>
</template>
<script>
import {
  ElProgress,
  ElMessage,
  // ElImage,
  ElPopover,
  ElRate
} from "element-plus";
import {
  getReportIndexDataV2,
  // getRecommendCar,
  getCarSummaryData,
} from "@/api";
import { ref, onUpdated } from "vue";
import { useRoute, useRouter } from "vue-router";
// import CarItem from "@/components/common/views/CarItem.vue";
import CarAttr from "@/components/common/views/CarAttr.vue";
import { getEnergyType } from "@/components/common/js/common.js";
import ModelList from "@/components/model/List.vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { ScatterChart, RadarChart } from "echarts/charts";
import VChart from "vue-echarts";
import {
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  MarkPointComponent,
  DataZoomComponent,
} from "echarts/components";
use([
  RadarChart,
  CanvasRenderer,
  ScatterChart,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  MarkPointComponent,
  DataZoomComponent,
]);
export default {
  name: "ReportIndex",
  components: {
    // CarItem,
    ElProgress,
    // ElImage,
    CarAttr,
    ModelList,
    ElPopover,
    // ElDialog
    VChart,
    ElRate
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    let changeCarObj =
      sessionStorage.getItem("changeCarId") &&
      JSON.parse(sessionStorage.getItem("changeCarId"));
    const allBaseData = ref([]);
    const data_loading = ref(true);
    const radar_chart_options = ref("");
    //我的车型评测列表
    const reportCarListRef = ref(null);
    const score_counts = ref([]);
    let { model_id, report_id } = route.query;
    const _getReportIndexDataV2 = () => {
      getReportIndexDataV2({
        model_id, report_id
      }).then((res) => {
        if (res.code == 200) {
          let { list: data, all_base_data, score_count } = res.data;
          score_counts.value = score_count;
          if (data && data.length > 0) {
            sessionStorage.setItem(
              "myFristReport",
              JSON.stringify({
                report_id: data[0].report_id,
                model_id: data[0].model_id,
              })
            );
          }
          if (changeCarObj && changeCarObj.model_id) {
            getCarSummaryData({
              model_id: changeCarObj.model_id,
            })
              .then((resp) => {
                if (resp.code == 200) {
                  for (let item of data) {
                    if (item.report_id == changeCarObj.report_id) {
                      item = resp.data;
                    }
                  }
                  reportCarListRef.value = data;
                } else {
                  reportCarListRef.value = data;
                  ElMessage.error(resp.message);
                }
              })
              .finally(() => {
                sessionStorage.removeItem("changeCarId");
              });
          } else {
            reportCarListRef.value = data;
          }
          console.log(reportCarListRef.value)
          let callData = reportCarListRef["value"][0];
          const trip_score_detail = callData.trip_score_detail;
          if (trip_score_detail) {
            const trip_arr = [];
            let index = 0;
            while (index < trip_score_detail.length) {
              trip_arr.push(trip_score_detail.slice(index, (index += 3)));
            }
            callData.trip_score_detail = trip_arr;
          }
          if (callData.function_score_detail) {
            const function_data = [],
              function_value = [];
            for (let item of callData.function_score_detail) {
              function_value.push((item.score / item.total_score) * 100);
              function_data.push({
                name: item.node_name,
                max: 100,
              });
            }
            radar_chart_options.value = {
              color: ["#fac858"],
              colorBy: "series",
              radar: {
                axisLine: {
                  show: false,
                },
                radius: "60%",
                name: {
                  color: "#777C89",
                  fontSize: 14,
                  lineHeight: 21,
                  width: 42,
                  overflow: "breakAll",
                },
                axisLabel: {
                  show: true,
                  formatter: "{value}%",
                  verticalAlign: "middle",
                  fontSize: 10,
                  margin: -8,
                },
                indicator: function_data,
              },
              series: [
                {
                  type: "radar",
                  textStyle: {
                    color: "#f00",
                  },
                  areaStyle: {
                    normal: {
                      color: "rgba(250,200,88,.4)", //填充的颜色
                    },
                  },
                  data: [
                    {
                      value: function_value,
                    },
                  ],
                },
              ],
            };
          }
          data_loading.value = false;
          allBaseData.value = all_base_data;
          setScatterOptions();
          // _getRecommendCar();
        } else if (res.code == 501) {
          //处理登录
        }
      });
    };
    _getReportIndexDataV2();
    //行业类别散点图
    let color_list = [
      "#5470c6",
      "#91cc75",
      "#fac858",
      "#ee6666",
      "#73c0de",
      "#3ba272",
      "#fc8452",
      "#9a60b4",
      "#ea7ccc",
    ];
    const scatterOptions = ref(null);
    const scatterOptions_big = ref(null);
    const preview_big = ref(false);
    const setScatterOptions = () => {
      let base_config = allBaseData.value;
      let seriesData = {};
      let series = [];
      let my_model = {};
      base_config.forEach((item) => {
        if (
          reportCarListRef.value[list_current_ind.value].model_id ==
          item.model_id
        ) {
          my_model = item;
        }
        if (item.camp && item.price > 0) {
          if (!seriesData[item.camp]) {
            seriesData[item.camp] = [];
          }
          seriesData[item.camp].push([
            item.price,
            item.total_score,
            item.model_name,
            item.camp,
          ]);
        }
      });
      color_list[Object.keys(seriesData).length] = "#f00";
      console.log(color_list);
      console.log(Object.keys(seriesData).length);
      seriesData[my_model.model_name] = [
        [
          my_model.price,
          my_model.total_score,
          my_model.model_name,
          my_model.camp,
        ],
      ];
      for (var key in seriesData) {
        series.push({
          name: key,
          type: "scatter",
          itemStyle: {
            opacity: 0.8,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "rgba(0,0,0,0.3)",
          },
          data: seriesData[key],
        });
      }
      const schema = [
        { name: "model_name", index: 0, text: "车型" },
        { name: "type", index: 1, text: "分类" },
        { name: "score", index: 2, text: "分数" },
        { name: "prise", index: 3, text: "价格" },
      ];
      console.log('series',series)
      scatterOptions.value = {
        color: color_list,
        legend: {
          left: "center",
          top: 0,
          data: Object.keys(seriesData),
          textStyle: {
            fontSize: 10,
          },
          itemWidth: 10,
          itemHeight: 10,
        },
        grid: {
                    show: true,
                    backgroundColor: "rgba(250, 250, 250, .6)",
                    borderColor: "rgba(255, 255, 255, 1)",
          left: "10%",
          right: 50,
          top: "18%",
          bottom: "10%",
        },
        tooltip: {
          backgroundColor: "rgba(255,255,255,0.7)",
          formatter: function (param) {
            var value = param.value;
            // prettier-ignore
            return  schema[0].text + '：' + value[2] + '<br>'
                  + schema[1].text + '：' + value[3] + '<br>'
                  + schema[2].text + '：' + value[1] + '<br>'
                  + schema[3].text + '：' + value[0] + '<br>'
          },
        },
        xAxis: {
          type: "value",
          name: "(万元)",
          nameGap: 16,
          nameTextStyle: {
            fontSize: 10,
          },
          splitLine: {
            show: false,
          },
          min: 10,
          // max:50,
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            type: "slider",
          },
        ],
        yAxis: {
          type: "value",
          name: "分数",
          nameLocation: "end",
          nameGap: 20,
          nameTextStyle: {
            fontSize: 10,
          },
          splitLine: {
            show: false,
          },
          min: function (value) {
            return Math.floor(value.min / 50) * 50 - 100 >= 0
              ? Math.floor(value.min / 50) * 50 - 100
              : 0;
          },
          max: function (value) {
            return (Math.floor(value.max / 50) + 1) * 50;
          },
          // interval:50
        },
        series,
        label: {
          show: true,
          fontSize: 10,
          formatter: function (param) {
            return param.data[2];
          },
          position: "top",
          minMargin: 2,
        },
      };
      console.log('scatterOptions', scatterOptions.value)
      scatterOptions_big.value = {
        ...scatterOptions.value,
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            type: "slider",
          },
        ],
        grid: {
                    show: true,
                    backgroundColor: "rgba(250, 250, 250, .6)",
                    borderColor: "rgba(255, 255, 255, 1)",
          left: "4%",
          right: 50,
          top: "10%",
          bottom: "10%",
        },
      };
    };
    const toPage = (path, model_id, report_id) => {
      const query = {};
      if (model_id) {
        query.model_id = model_id;
      }
      if (report_id) {
        query.report_id = report_id;
      }
      router.push({
        path,
        query,
      });
    };
    const changeCar = (model_id) => {
      let ids = [];
      for (let item of reportCarListRef.value) {
        ids.push(Number(item.car_info.model_id));
      }
      router.push({
        path: "/report/change_model",
        query: {
          model_id,
          not_in_id: ids.join(","),
        },
      });
    };
    const carAttrDrawer = ref(null);
    const openCarAttrDrawer = (model_id) => {
      carAttrDrawer.value.carAttrDrawer = true;
      carAttrDrawer.value.model_id = model_id;
    };
    onUpdated(() => {
      changeCarObj =
        sessionStorage.getItem("changeCarId") &&
        JSON.parse(sessionStorage.getItem("changeCarId"));
    });
    const list_current_ind = ref(0);
    const changeModel = (id) => {
      reportCarListRef.value.forEach((item, ind) => {
        if (item.car_info.model_id == id) {
          list_current_ind.value = ind;
          return;
        }
      });
      setScatterOptions();
    };

    const video_name = ref("");
    const video_src = ref("");
    const video_show = ref(false);
    const playVideo = (video_obj) => {
      video_name.value = video_obj.node_name;
      video_src.value = video_obj.attach_value;
      video_show.value = true;
    };
    const stopVideo = () => {
      video_name.value = "";
      video_src.value = "";
      video_show.value = false;
    };

    return {
      reportCarListRef,
      scatterOptions,
      scatterOptions_big,
      preview_big,
      toPage,
      getEnergyType,
      // recommendCarListRef,
      changeCar,
      carAttrDrawer,
      openCarAttrDrawer,
      list_current_ind,
      changeModel,
      data_loading,
      video_src,
      video_show,
      playVideo,
      stopVideo,
      radar_chart_options,
      score_counts,
    };
  },
};
</script>
<style scoped lang="less">
.sprite_icon {
  &.icon_cxcs {
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cxcs_20230106.svg)
      no-repeat center center;
    background-size: 19px 19px;
  }
  &.icon_jcdf {
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jcdf_20230106.svg)
      no-repeat center center;
    background-size: 19px 19px;
  }
  &.icon_cxdf {
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/cxdf_20230106.svg)
      no-repeat center center;
    background-size: 14px 21px;
  }
  &.icon_hypj {
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/hypj_20230106.svg)
      no-repeat center center;
    background-size: 19px 14px;
  }
  &.icon_lbfb {
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/lbfb_20230106.svg)
      no-repeat center center;
    background-size: 14px 14px;
  }
  &.icon_gngl {
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gngl_20230106.svg)
      no-repeat center center;
    background-size: 17px;
  }
  &.icon_ltcj {
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ltcj_20230106.svg)
      no-repeat center center;
    background-size: 14px;
  }
  width: 24px;
  height: 24px;
}
.tip_icon {
  display: block;
  margin: 0 2px;
  width: 17px;
  height: 17px;
  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/c33656821a1100392efd965678caf39d.png)
    no-repeat top center;
  background-size: 16px 16px;
}
.report_container {
  padding-bottom: 50px;
  color: #474747;
  font-size: 14px;
  display: inline-block;
  min-width: 1090px;
  min-height: 100%;

  .list_header {
    position: relative;
    height: 36px;
    padding: 0 20px;
    font-size: 12px;
    color: #777c89;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 10px;
    h2 {
      font-size: 18px;
      font-weight: bold;
      color: #474747;
      margin-right: 5px;
      &:before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 5px;
        height: 20px;
        background: #52b0d6;
        border-radius: 1px;
      }
    }
  }
  .item_block {
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 13px;
    overflow: hidden;
    .car_score_item_tit {
      height: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #474747;
      margin-bottom: 36px;
      .sprite_icon {
        margin-right: 15px;
      }
      .car_score_num {
        font-size: 16px;
        font-weight: bold;
        color: #e46c6c;
      }
      .car_score_item_detail_btn {
        font-size: 14px;
        font-weight: 400;
        color: #404e5b;
        appearance: none;
        outline: none;
        text-decoration: none;
        margin-left: auto;
        // background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/right_20230106.png)
        //   no-repeat right center;
        // background-size: 8px;
        // padding-right: 22px;
      }
      .preview_big {
        margin-left: auto;
        font-size: 14px;
        color: #404e5b;
        cursor: pointer;
      }
    }
  }

  .report_list {
    width: 1090px;
    .cur_car_info {
      .cur_car_info_top {
        justify-content: space-between;
        padding: 46px 43px 30px 0;
        .cur_car_info_left {
          width: 532px;
          display: flex;
          flex-direction: column;
          // justify-content: flex-end;
          align-items: center;
          .cur_car_info_img {
            width: 350px;
            height: 175px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .cur_car_info_name {
            font-size: 18px;
            color: #474747;
            line-height: 24px;
            font-weight: 600;
          }
          .car_info_change_model {
            cursor: pointer;
            margin-top: 12px;
            width: 70px;
            height: 23px;
            line-height: 23px;
            font-size: 12px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #b8c0d6;
            text-align: center;
            color: #6171a4;
          }
          .cur_car_info_price {
            margin-top: 14px;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #474747;
            line-height: 19px;
            .price_attr {
              font-weight: 300;
            }
            .price_val {
              font-weight: 600;
            }
          }
          .cur_car_info_starts{
            margin-top: 10px;
          }
        }
        .cur_car_info_right {
          width: 473px;
          .cur_car_info_right_top {
            .cur_car_info_right_item {
              width: 160px;
              .cur_car_info_item_attr,
              .cur_car_info_test_attr {
                font-size: 16px;
                color: #474747;
                line-height: 21px;
                &.score_composite_attr {
                  align-items: center;
                }
              }
              .cur_car_info_item_val {
                width: 70px;
                text-align: center;
                margin-top: 3px;
                font-size: 32px;
                font-weight: bold;
                color: #e46c6c;
                line-height: 43px;
                letter-spacing: 1px;
              }

              &.cur_car_info_test_time {
                width: 150px;
                border-left: solid 1px #e6e6e6;
                padding-left: 36px;
                .cur_car_info_test_val {
                  margin-top: 15px;
                  font-size: 18px;
                  color: #474747;
                  line-height: 24px;
                  font-weight: 600;
                }
              }
            }
          }
          .cur_car_info_experts_read {
            margin-top: 23px;
            width: 473px;
            height: 156px;
            background: #f9f9f9;
            border-radius: 8px;
            padding: 21px 29px 0 24px;
            .experts_read_attr {
              font-size: 14px;
              font-weight: bold;
              color: #0b0b0b;
              line-height: 19px;
            }
            .experts_read_desc {
              margin-top: 13px;
              font-size: 13px;
              color: #4d505a;
              line-height: 20px;
            }
          }
          .cur_car_info_btns {
            margin-top: 12px;
            justify-content: space-between;
            .cur_car_info_btn {
              width: 230px;
              height: 69px;
              border: solid 1px #e5e5e5;
              border-radius: 8px;
              // padding-top: 14px;
              // padding-left: 23px;
              appearance: none;
              text-decoration: none;
              display: flex;
              align-items: center;
              justify-content: space-between;
              &:hover {
                box-shadow: 0px 0px 12px 0px rgba(14, 59, 139, 0.12);
                border: none;
              }
              .cur_car_info_btn_icon {
                width: 60px;
                height: 60px;
                &.icon_gnbgfx {
                  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gnbgfx_20230106.svg)
                    no-repeat center center;
                  background-size: 23px 23px;
                }
                &.icon_hxcjfx {
                  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/hxcjfx_20230106.svg)
                    no-repeat center center;
                  background-size: 33px 32px;
                }
                &.icon_right {
                  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/car_info_btn_right.jpg)
                    no-repeat center center;
                  background-size: 23px 23px;
                }
              }
              .cur_car_info_btn_text {
                width: 120px;
              }
              // &.btn_function{
              //   background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/82051666072772_.jpg) no-repeat right bottom;
              //   background-size: 100% 100%;
              // }
              // &.btn_scenario{
              //   background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/82061666072772_.jpg) no-repeat right bottom;
              //   background-size: 100% 100%;
              // }
              .cur_car_info_btn_tit {
                font-size: 14px;
                font-weight: bold;
                color: #474747;
                line-height: 19px;
                letter-spacing: 1px;
              }
              .cur_car_info_btn_desc {
                margin-top: 4px;
                font-size: 12px;
                color: #474747;
                line-height: 16px;
              }
            }
          }
        }
      }
      .cur_car_info_bot {
        padding: 0 43px 33px 39px;
        .cur_car_info_parameter {
          justify-content: space-between;
          align-items: center;
          .cur_car_info_parameter_tit {
            font-size: 16px;
            font-weight: bold;
            color: #474747;
            letter-spacing: 1px;
            margin-left: 18px;
          }
          .cur_car_info_parameter_btn {
            cursor: pointer;
            font-size: 14px;
            color: #404e5b;
            margin-left: auto;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/chakanxiangqing_right.png)
              no-repeat right center;
            background-size: 8px;
            padding-right: 22px;
          }
        }
        .parameter_details {
          justify-content: space-around;
          .parameter_detail_item {
            padding-top: 25px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .parameter_detail_item_icon {
              width: 50px;
              height: 45px;
              &.icon_nylx {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/nylx.png)
                  no-repeat center center;
                background-size: 29px;
              }
              &.icon_xtmc {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/xtmc.png)
                  no-repeat center center;
                background-size: 26px;
              }
              &.icon_xtbb {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/xtbb.png)
                  no-repeat center center;
                background-size: 27px;
              }
              &.icon_ykzqgys {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/ykzqgys.png)
                  no-repeat center center;
                background-size: 28px;
              }
              &.icon_zkxp {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/zkxp.png)
                  no-repeat center center;
                background-size: 29px;
              }
              &.icon_fzjsjb {
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fzjsjb.png)
                  no-repeat center center;
                background-size: 30px;
              }
            }
            .parameter_detail_item_attr {
              font-size: 12px;
              color: #777c89;
              line-height: 19px;
            }
            .parameter_detail_item_val {
              margin-top: 8px;
              font-size: 14px;
              font-weight: bold;
              color: #474747;
              line-height: 19px;
            }
          }
        }
      }
    }

    .car_score_group {
      .car_score_item {
        background: #ffffff;
        border-radius: 4px;
        padding: 40px 53px;
        margin-bottom: 13px;
        &.car_score_base {
          width: 538px;
        }
        &.car_score_innovate {
          width: 538px;
        }
        .score_box {
          height: 200px;
          justify-content: space-between;
          .score_item {
            padding-left: 4px;
            .score_item_top {
              font-size: 14px;
              .score_item_label {
                height: 21px;
                font-size: 14px;
                color: #474747;
                line-height: 21px;
                font-weight: bold;
                .score_item_node_name {
                  font-weight: normal;
                }
                .font_000 {
                  color: #000000;
                }
              }
            }
            .score_item_bottom {
              margin-top: 6px;
              .score_item_innovete {
                width: 4px;
                height: 6px;
                background: #1fbcbf;
                border-radius: 10px;
              }
            }
          }
        }
      }
    }
    .car_graph {
      .car_hypj {
        width: 538px;
        height: 380px;
        padding: 30px 0 0 43px;
        .analyse_chart {
          padding-left: 20px;
        }
        .hypj {
          position: relative;
          .score_counts {
            position: absolute;
            top: 0;
            left: 158px;
            text-align: center;
            z-index: 5;
            padding-top: 38px;
            width: 100px;
            font-size: 12px;
            .score_count {
              line-height: 15px;
              margin-bottom: 30px;
            }
          }
          .hypj_score {
            position: absolute;
            top: -7px;
            left: 0;
            .hypj_score_item {
              height: 48px;
              text-align: right;
            }
          }
        }
        .hypj_content {
          width: 100%;
          height: 260px;
          position: relative;
          .hypj_active {
            position: absolute;
            height: 48px;
            width: 120px;
            display: flex;
            align-items: center;
            .hypj_active_icon {
              width: 14px;
              height: 17px;
              background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/35e9c86bd13a9ed2e1d901e7c2ee3149.png)
                no-repeat;
              background-size: 100%;
              margin-right: 10px;
            }
            .hypj_active_info {
              .hypj_active_info_name {
                font-size: 12px;
                color: #474747;
                line-height: 16px;
              }
              .hypj_active_info_score {
                font-size: 15px;
                font-weight: bold;
                color: #2a2a2a;
                line-height: 20px;
              }
            }
          }
          &.hypj_level1 {
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jzt1_20230109.png)
              no-repeat left center;
            background-size: 350px;
            .hypj_active {
              height: 50px;
              left: 242px;
              top: 9px;
            }
          }
          &.hypj_level2 {
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jzt2_20230109.png)
              no-repeat left center;
            background-size: 350px;
            .hypj_active {
              height: 50px;
              left: 270px;
              top: 56px;
            }
          }
          &.hypj_level3 {
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jzt3_20230109.png)
              no-repeat left center;
            background-size: 350px;
            .hypj_active {
              left: 298px;
              top: 104px;
            }
          }
          &.hypj_level4 {
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jzt4_20230109.png)
              no-repeat left center;
            background-size: 350px;
            .hypj_active {
              height: 46px;
              left: 325px;
              top: 152px;
            }
          }
          &.hypj_level5 {
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/jzt5_20230109.png)
              no-repeat left center;
            background-size: 350px;
            .hypj_active {
              height: 46px;
              left: 350px;
              top: 198px;
            }
          }
        }
      }
      .car_lbfb {
        width: 538px;
        height: 380px;
        padding: 30px 43px;
        .car_score_item_tit {
          margin-bottom: 26px;
        }
        .lbfb_content {
          width: 500px;
          height: 285px;
        }
      }
      .score_func {
        width: 538px;
        height: 450px;
        background: #fff;
        background: #ffffff;
        border-radius: 4px;
        padding: 40px 53px 0;
        .car_score_item_tit {
          margin-bottom: 0;
        }
        .chart_box {
          margin-top: 10px;
          width: 500px;
          height: 368px;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: visible;
          transform: translateX(-35px);
        }
      }
      .score_trip {
        width: 538px;
        height: 450px;
        padding-top: 2px;
        background: #ffffff;
        border-radius: 4px;
        padding: 40px 53px 0;
        .score_tit {
          padding-left: 38px;
        }
        .car_score_item_tit {
          margin-bottom: 20px;
        }
        .score_trip_box {
          width: 100%;
          height: 306px;
          padding-top: 10px;
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ltcj_bg_20230106.png)
            no-repeat center center;
          background-size: 360px;
          .score_row {
            margin: 0 auto;
            width: 397px;
            height: 104px;
            display: flex;
            justify-content: center;
            padding-top: 18px;
            &:nth-child(2) {
              flex-direction: row-reverse;
            }
            .score_item {
              width: 100px;
              .score_item_attr {
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 14px;
                color: #777c89;
              }
              .score_item_val {
                height: 21px;
                font-size: 16px;
                text-align: center;
                font-weight: bold;
                color: #e7816e;
                line-height: 21px;
                margin-top: 22px;
              }
            }
          }
        }
      }
    }
  }
}

.light_video {
  padding: 42px 0 20px 44px;
  display: flex;
  flex-wrap: wrap;
  .video_item {
    margin-right: 20px;
    .video_item_img {
      width: 236px;
      height: 133px;
      border-radius: 6px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      video {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &::after {
        content: "";
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4)
          url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/relative_video_item_bf.png)
          no-repeat center center;
        background-size: 40px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .video_item_tit {
      display: flex;
      align-items: center;
      width: 236px;
      height: 64px;
      font-size: 14px;
      color: #474747;
      line-height: 19px;
    }
  }
}
.video_content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.video_pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .video_content {
    width: 100%;
    height: 100%;
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .video_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png)
        no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      right: 50px;
      top: 50px;
    }
  }
}
.preview_big_box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 1);
  .btn_close {
    width: 60px;
    height: 60px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png)
      no-repeat center center;
    background-size: 60px 60px;
    border-radius: 50%;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    box-shadow: 0 0 10px 3px #f5f5f5;
  }
}

.appraisal_left_tit {
  display: flex;
  align-items: center;
  padding-left: 16px;
  height: 26px;
  font-size: 16px;
  font-weight: bold;
  color: #474747;
  line-height: 26px;
  position: relative;

  &::before {
    content: "";
    width: 4px;
    height: 14px;
    background: #e7816e;
    position: absolute;
    top: 6px;
    left: 0;
  }
  .appraisal_left_tit_val {
    color: #e7816e;
    margin-right: 10px;
  }
  .look_detail {
    width: 66px;
    height: 21px;
    line-height: 20px;
    text-align: center;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #5390f1;
    font-size: 12px;
    color: #4c96e9;
    font-weight: normal;
    cursor: pointer;
  }
}
</style>